// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"272":"9db1c4b0","547":"a57daa20","575":"9db1c4b0"}[chunkId] + ".chunk.css";
};